import React from "react";

const techUsed = () => {
  return (
    <div>
      <h2>Technologies Used</h2>
      <hr />
      <ul>
        <li>* C#</li>
        <li>* ASP.NET Core</li>
        <li>* Entity Framework Core</li>
        <li>* MySQL</li>
        <li>* LINQ</li>
        <li>* Postman</li>
        <li>* Swagger</li>
      </ul>
    </div>
  );
};

export default techUsed;
